<template>
  <div class="model-table">
    <ModuleTitleView :title="data?.title || ''"></ModuleTitleView>
    <div class="model-table-container" v-for="(item, index) in data?.data?.data" :key="index">
      <div class="model-table-container-title">{{ item?.title || '' }}</div>
      <div>
        <table class="model-table-container-custom-table">
          <thead>
          <tr>
            <th v-for="(subItem,index) in item?.table_title" :key="index" :colspan="subItem?.column_num">{{
                subItem.text
              }}
            </th>
          </tr>
          </thead>
          <tbody>
          <template v-for="item in item?.table_content" :key="item.index">
            <tr>
              <td v-if="item.index === 0"
                  :rowspan="item?.row_num"
                  :class="{'table-td-first': item.index === 0 }">
                {{ item?.model_type }}
              </td>
              <td :class="{ 'have-border_1' : item?.row_num > 1 || item?.row_num === 1 }">
                <router-link to="/model-guide" target="_blank">{{
                    item?.model_id_1 ? item?.model_id_1 : '-'
                  }}
                </router-link>
              </td>
              <td :class="{ 'have-border_2' : item?.row_num > 1 || item?.row_num === 1 }">
                <router-link to="/model-guide" target="_blank">{{
                    item?.model_id_2 ? item?.model_id_2 : '-'
                  }}
                </router-link>
              </td>
              <td :class="{ 'have-border_3' : item?.row_num > 1 || item?.row_num === 1 }">
                <router-link to="/model-guide" target="_blank">{{
                    item?.model_id_3 ? item?.model_id_3 : '-'
                  }}
                </router-link>
              </td>
              <td :class="{ 'have-border_4' : item?.row_num > 1 || item?.row_num === 1 }">
                <router-link to="/model-guide" target="_blank">{{
                    item?.model_id_4 ? item?.model_id_4 : '-'
                  }}
                </router-link>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>

import ModuleTitleView from "@/components/actricle/ModuleTitleView.vue"

const props = defineProps({
  jsonData: Object,
})

const data = reactive(props.jsonData)

const modelClick = () => {
  window.open({name: 'modelGuide'})
}

</script>

<script>
export default {
  name: 'ModelTable'
}
</script>

<style scoped lang="less">

.model-table {
  width: 100%;
  margin-top: 50px;
  overflow: hidden;

  .model-table-container {
    margin-top: 50px;

    .model-table-container-title {
      font-size: 18px;
      font-weight: bold;
      color: var(--main-color);
      letter-spacing: 1px;
    }

    .model-table-container-custom-table {
      width: 100%;
      margin-top: 30px;
      border-collapse: collapse;
      border-spacing: 0;
      border-top: 3px solid var(--main-color);

      thead tr th {
        width: 250px;
        text-align: center;
        font-size: 16px;
        padding-top: 13px;
        padding-bottom: 13px;
        color: var(--main-color);
        letter-spacing: 1px;
      }

      tbody tr td {
        width: 250px;
        text-align: center;
        font-size: 16px;
        padding-top: 13px;
        padding-bottom: 13px;
        color: var(--font-color);
        letter-spacing: 1px;
      }

      tbody tr td {
        border-top: 2px solid var(--line-color);
      }

      .table-td-first {
        font-weight: bold;
        color: var(--main-color);
      }

      tbody tr:last-child {
        border-bottom: 3px solid var(--main-color);
      }

      thead tr {
        border-bottom: 3px solid var(--main-color);
      }

      tbody tr:nth-child(1) td {
        border-top: 2px solid var(--main-color);
      }

      .have-border_1 {
        border-left: 2px solid var(--line-color);
        cursor: pointer;

        :hover {
          color: var(--main-sub-color);
        }
      }

      .have-border_2 {
        border-left: 2px solid var(--line-color);
        cursor: pointer;

        :hover {
          color: var(--main-sub-color);
        }
      }

      .have-border_3 {
        border-left: 2px solid var(--line-color);
        cursor: pointer;

        :hover {
          color: var(--main-sub-color);
        }
      }

      .have-border_4 {
        border-left: 2px solid var(--line-color);
        cursor: pointer;

        :hover {
          color: var(--main-sub-color);
        }
      }
    }
  }
}

</style>
